import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Form, Button } from 'antd';
import AuthInfo from '../../components/AuthInfo/AuthInfo';
import AuthForm from '../../components/AuthForm/AuthForm';
import OTPInput from '../../components/OTPInput';
import './ForgotPassword.scss';
import { toastNotify } from '../../utils/toastNotify';

const ForgotPassword = () => {
  // const [pin, setPin] = useState(undefined);
  const [viewForm, setViewForm] = useState(false);
  let navigate = useNavigate();
  let DummyPin = '1234';
  const handleEnterPin = (pin) => {
    if (pin.length === 4) {
      //call the api
      if (pin === DummyPin) {
        navigate('/forgot-password/enter-email');
      } else {
        toastNotify('error', 'please enter a valid pin');
      }
    }
  };
  return (
    <div className='auth auth--details auth--no-info-mobile login'>
      <AuthInfo
        className={viewForm ? 'hide' : null}
        title={<>Welcome back</>}
        description={<>Enter your credentials to access your Realbricks account.</>}
      >
        <div className='mobile-action' onClick={() => setViewForm(true)}>
          <Button className='w-100'>Get Started</Button>
        </div>
      </AuthInfo>
      <AuthForm className={viewForm ? 'show' : null} title={<>Enter your 4-digit PIN</>}>
        <Form className='auth-form pin-form login-pin'>
          <div className='pin-field mb-24'>
            <OTPInput length={4} onChangeOTP={(otp) => handleEnterPin(otp)} className='otp' autoFocus inputClassName='otp__input' />
          </div>
          <Link to='/forgot-pin' className='underline text-terracotta fw-600'>
            I forgot my PIN
          </Link>
        </Form>
      </AuthForm>
    </div>
  );
};

export default ForgotPassword;
